import React from "react";
import Styles from "./ContactUs.module.css";

import { useTranslation } from "react-i18next";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import fbIcon from "../assets/Icons//Facebook.svg";
import twitterIcon from "../assets/Icons/Twitter.svg";
import instagramIcon from "../assets/Icons/Instagram.svg";
import GoToTop from "../components/GotoTop";

function ContactUs() {
	const { t, i18n } = useTranslation();

	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";

	return (
		<div className={Styles.container}>
			<GoToTop/>
			<div
				className={Styles.wrapContact}
				dir={isRtl ? "rtl" : "ltr"}
			>
				<h2 className={Styles.h2}>
					{t("Contactus.title")}
				</h2>
				<p className={Styles.p}>
					{t("Contactus.paragraph1")}
				</p>
				<h3 className={isRtl ? Styles.h3Rtl : Styles.h3}>
					{t("Contactus.contact")}
				</h3>

				<p className={Styles.p}>
					{t("Contactus.paragraph2")}
				</p>

				<button className={Styles.btn}>
					<a
						href='whatsapp://send?phone=7818403457'
						target='_blank'
						rel='noreferrer' //for security
					>
						{t("Contactus.contactWhats")}
						<WhatsAppIcon />
					</a>
				</button>

				<h3 className={isRtl ? Styles.h3Rtl : Styles.h3}>
					{t("Contactus.titleFollow")}
				</h3>
				<p className={Styles.p}>
					{t("Contactus.paragraphFollow")}
				</p>
				<div className={Styles.iconsContainer}>
					<a
						href='https://www.facebook.com/'
						target='_blank'
						rel='noreferrer'
					>
						<img
							className={Styles.icon}
							src={fbIcon}
							alt='Facebook Icon'
						/>
					</a>

					<a
						href='https://twitter.com/?lang=en'
						target='_blank'
						rel='noreferrer'
					>
						<img
							className={Styles.icon}
							src={twitterIcon}
							alt='Twitter Icon'
						/>
					</a>

					<a
						href='https://www.instagram.com/'
						target='_blank'
						rel='noreferrer'
					>
						<img
							className={Styles.icon}
							src={instagramIcon}
							alt='Instagram Icon'
						/>
					</a>
				</div>
			</div>
		</div>
	);
}

export default ContactUs;
